/* @flow weak */
import React from 'react';
import Time from 'components/Time.jsx';

class Timestamp extends React.Component {
  static propTypes = {
    date: React.PropTypes.instanceOf(Date).isRequired,
    format: React.PropTypes.oneOf(['short', 'long', 'time']),
  };

  static defaultProps = {
    format: 'long',
  };

  shouldComponentUpdate(nextProps) {
    const same = (
      this.props.date.getTime() === nextProps.date.getTime() &&
      this.props.format === nextProps.format
    );
    return !same;
  }

  getDayInterval = (date) => {
    return Math.floor(
      (date.getTime() - date.getTimezoneOffset() * 60 * 1000) / (1000 * 60 * 60 * 24)
    );
  };

  getDayIntervalDifference = (a, b) => {
    return this.getDayInterval(a) - this.getDayInterval(b);
  };

  renderTimestamp = () => {
    const { format, date } = this.props;
    if (format !== 'time') {
      const diff = this.getDayIntervalDifference(date, new Date());

      if (format === 'long') {
        if (Math.abs(diff) >= 7) {
          // Show full date (e.g., March 26, 2015)
          return <Time date={date} month="long" day="numeric" year="numeric" />;
        } else if (Math.abs(diff) >= 2) {
          // Show full weekday (e.g., Sunday)
          return <Time date={date} weekday="long" />;
        } else if (Math.abs(diff) === 1) {
          return (
            <span>
              {diff > 0 ? 'Tomorrow' : 'Yesterday'}
            </span>
          );
        } else {
          return (
            <span>
              Today
            </span>
          );
        }
      } else {
        if (diff >= 365) {
          // Show full numeric date (e.g., 3/28/15)
          return <Time date={date} month="numeric" day="numeric" year="2-digit" />;
        } else if (diff >= 7) {
          // Show abbreviated date (e.g., Jun 12)
          return <Time date={date} month="short" day="numeric" />;
        } else if (diff >= 1) {
          // Show abbreviated weekday (e.g., Sun)
          return <Time date={date} weekday="short" />;
        }
      }
    }

    // Just the time (e.g., 11:32 AM)
    return <Time date={date} hour="numeric" minute="2-digit" />;
  };

  render() {
    return React.cloneElement(this.renderTimestamp(), {
      className: this.props.className,
      title: this.props.date.toString(),
    });
  }
}

export default Timestamp;



// WEBPACK FOOTER //
// ./src/components/Timestamp.jsx